import React, { useState } from 'react'

import {Loader} from '../';

import './imageBuffer.css'

interface ImageBufferProps {
    onClick?: () => void;
    src?: string;
    alt: string;
    index?: number;
    className?: string;
}

const ImageBuffer: React.FC<ImageBufferProps> = ({ src, alt, index, className, onClick }) => {
    const [imageLoading, setImageLoading] = useState<Record<number, boolean>>({});

    const handleImageLoad = (index: number) => {
        setImageLoading((prevState) => ({ ...prevState, [index]: false }));
    };

    const handleImageError = (index: number) => {
        setImageLoading((prevState) => ({ ...prevState, [index]: false }));
    };

    const handleImageLoading = (index: number) => {
        setImageLoading((prevState) => ({ ...prevState, [index]: true }));
    };

    const isLoading = typeof index === 'number' && imageLoading[index];

  return (
    <>
        {isLoading && <Loader />}
        <img
            src={src}
            alt={alt}
            onClick={onClick}
            onLoad={() => index !== undefined && handleImageLoad(index)}
            onError={() => index !== undefined && handleImageError(index)}
            onLoadStart={() => index !== undefined && handleImageLoading(index)}
            style={{ display: isLoading ? 'none' : 'block' }}
            className={className}
        />
    </>
  )
}

export default ImageBuffer